import { render, staticRenderFns } from "./CartItemAttachments.vue?vue&type=template&id=3b255107&scoped=true"
import script from "./CartItemAttachments.vue?vue&type=script&lang=js"
export * from "./CartItemAttachments.vue?vue&type=script&lang=js"
import style0 from "./CartItemAttachments.vue?vue&type=style&index=0&id=3b255107&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b255107",
  null
  
)

export default component.exports